(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('FileUtilCustom', FileUtilCustom);

    FileUtilCustom.$inject = ['$resource', 'ENV'];

    function FileUtilCustom($resource, ENV) {


        var supplierFileUploadToServer = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/supplier-upload-file';
            return $resource(resourceUrl, {}, {
                    'upload': {
                        method: "POST",
                        // transformRequest: angular.identity,
                        headers: {'Content-Type': undefined}
                    }
                }
            );
        }
        var getFileUrlPrefix = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/get-file-url-prefix-by-current-company';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        }


        // var downloadSupplierFileByName = function (fileName) {
        //     var resourceUrl='api/download-supplier-file-by-name/'+fileName;
        //     return $resource(resourceUrl, {}, {
        //             'get': { method: 'GET', isArray: false}
        //         }
        //
        //     );
        // }

        var downloadSupplierFileByName = function (fileName, directory) {

            var resourceUrl = ENV.API_BASE_URL + 'api/client/download-supplier-file-by-name?fileName=' + fileName + '&directory=' + directory;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        }

        var getSupplierFileDownloadLink = function (fileName) {

            var resourceUrl = ENV.API_BASE_URL + 'api/get-supplier-file-download-link?fileName=' + fileName;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        }

        return {
            supplierFileUploadToServer: supplierFileUploadToServer,
            getFileUrlPrefix: getFileUrlPrefix,
            downloadSupplierFileByName: downloadSupplierFileByName,
            getSupplierFileDownloadLink: getSupplierFileDownloadLink


        };
    }
})();
